import { snackbar } from "@/core/controller/snackbar_controller";
import { headers } from "../const/headers";
import { headersExcel } from "../const/headersExcel";
import { hadPermission } from "@/core/domain/model/permission";
import { equipmentDefault } from "../domain/equipment/equipment";
import QRCodeReport from "@/helpers/qrCodeReport";
import { hadColumnsAccess } from '@/core/domain/model/permission';
import { generateExcelFile } from '@/helpers/excelExportHelper';
import * as XLSX from "xlsx";

class EquipmentController {
  context = null;
  permissionID = 2;
  headers = headers;
  updateItensHeaders = [{
    text: 'Serial',
    align: 'start',
    sortable: true,
    value: 'name',
    divider: true
  },
  {
    text: 'Modelo',
    align: 'start',
    sortable: true,
    value: 'model',
    divider: true
  }]
  loading = false
  loadingBtnExcel = false
  search = ""
  searchModel = ""
  searchVehicle = ""
  searchEquipmentType = ""
  searchClient = ""
  modelIDToInclude = null
  vehicleIDToInclude = null
  clientIDToInclude = null
  dialog = false
  dialogUpdateClient = false
  dialogUpdateVehicle = false
  dialogGenerateQrCode = false
  clientIDForUpdate = null
  loadingUpdateClient = false
  loadingUpdateVehicle = false
  dialogGenerateQrCodeCreated = false
  dialogPreviewImport = false
  previewData = []
  loadingImport = false
  headersImport = [
    { text: 'Serial', value: 'name' },
    { text: 'Modelo', value: 'modelName' },
    { text: 'Placa', value: 'plateNumber' },
    { text: 'Tipo Equipamento', value: 'equipmentTypeName' },
    { text: 'MAC', value: 'mac' },
    { text: 'Cliente', value: 'clientName' },
    { text: 'Descrição', value: 'description' },
    { text: 'Ativo', value: 'active'}
  ]
  form = equipmentDefault()
  searchVehicleInModal = ""
  searchModelInModal = ""   
  searchClientInModal = ""
  searchTechnicianInModal = ""
  formCode = {}
  formUpdateVehicle = {}
  searchVehicleInUpdateModal = ""
  searchClientInUpdateModal = "" 
  statusPaginated = 1 // Always active
  statusSelected = 1
  statusList = [
    { text: "Todos", value: 0 },
    { text: "Ativo", value: 1 },
    { text: "Inativo", value: 2 },
  ]

  reason = ["Instalação nova", "Manutenção no veículo", "Bloqueado", "Manutenção externa"]

  totalEquipmentsPlate = {}

  selectedItems = []
  equipmentPagination = {
    total: 0,
    items: []
  }

  options = {
    page: 1,
    itemsPerPage: 40,
    groupBy: [],
    sortBy: ["id"],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    sortDesc: []
  }

  modelPagination = {
    total: 0,
    items: []
  }

  modelOptions = {
    page: 1,
    itemsPerPage: 100,
    groupBy: [],
    sortBy: ["name"],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    sortDesc: []
  }


  vehiclePagination = {
    total: 0,
    items: []
  }

  vehicleOptions = {
    page: 1,
    itemsPerPage: 100,
    groupBy: [],
    sortBy: ["plate"],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    sortDesc: []
  }


  equipmentTypePagination = {
    total: 0,
    items: []
  }

  equipmentTypeOptions = {
    page: 1,
    itemsPerPage: 40,
    groupBy: [],
    sortBy: ["id"],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    sortDesc: []
  }

  clientPagination = {
    total: 0,
    items: []
  }

  clientOptions = {
    page: 1,
    itemsPerPage: 100,
    groupBy: [],
    sortBy: ["name"],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    sortDesc: []
  }

  technicianPagination = {
    total: 0,
    items: []
  }

  technicianOptions = {
    page: 1,
    itemsPerPage: 100,
    groupBy: [],
    sortBy: ["name"],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    sortDesc: []
  }

  code = {}

  constructor(
    context,
    fetchEquipmentUseCaseImpl,
    createEquipmentUseCaseImpl,
    changeEquipmentUseCaseImpl,
    deleteEquipmentUseCaseImpl,
    fetchModelUseCaseImpl,
    fetchVehicleUseCaseImpl,
    fetchEquipmentTypeUseCaseImpl,
    countEquipmentPlateUseCaseImpl,
    fetchClientUseCaseImpl,
    fetchTechnicianUseCaseImpl,
    createReleaseUseCaseImpl,
    refreshUseCaseImpl
  ) {
    this.context = context;
    this.fetchEquipmentUseCaseImpl = fetchEquipmentUseCaseImpl
    this.createEquipmentUseCaseImpl = createEquipmentUseCaseImpl
    this.changeEquipmentUseCaseImpl = changeEquipmentUseCaseImpl
    this.deleteEquipmentUseCaseImpl = deleteEquipmentUseCaseImpl
    this.fetchModelUseCaseImpl = fetchModelUseCaseImpl
    this.fetchVehicleUseCaseImpl = fetchVehicleUseCaseImpl
    this.fetchEquipmentTypeUseCaseImpl = fetchEquipmentTypeUseCaseImpl
    this.countEquipmentPlateUseCaseImpl = countEquipmentPlateUseCaseImpl
    this.fetchClientUseCaseImpl = fetchClientUseCaseImpl
    this.fetchTechnicianUseCaseImpl = fetchTechnicianUseCaseImpl
    this.createReleaseUseCaseImpl = createReleaseUseCaseImpl
    this.refreshUseCaseImpl = refreshUseCaseImpl
  }

  getColumnsAccess() {
    return this.headers.filter(header => hadColumnsAccess(header.value, this.permissionID))
  }

  async paginate() {
    this.loading = true
    try {
      this.equipmentPagination = await this.fetchEquipmentUseCaseImpl(this.options, this.search, this.statusSelected)
      this.totalEquipmentsPlate = await this.countEquipmentPlateUseCaseImpl()
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false
    }
  }
  async modelPaginate() {
    try {
      const newPaginationData = await this.fetchModelUseCaseImpl(this.modelOptions, this.searchModel || this.searchModelInModal, this.statusPaginated, this.modelIDToInclude)

      const currentSelectedItem = this.modelPagination.items.find(
        (v) => v.id === this.form.modelID
      )

      if (currentSelectedItem && !newPaginationData.items.some(v => v.id === currentSelectedItem.id)) {
        newPaginationData.items.unshift(currentSelectedItem)
      }
      this.modelPagination = newPaginationData
    } catch (error) {
      console.log(error);
    }
  }

  async vehiclePaginate() {
    try {
      const newPaginationData = await this.fetchVehicleUseCaseImpl(this.vehicleOptions, this.searchVehicle || this.searchVehicleInModal || this.searchVehicleInUpdateModal, this.statusPaginated, this.vehicleIDToInclude
      )

      const currentSelectedItem = this.vehiclePagination.items.find(
        (v) => v.id === this.form.vehicleID
      )

      if (currentSelectedItem && !newPaginationData.items.some(v => v.id === currentSelectedItem.id)) {
        newPaginationData.items.unshift(currentSelectedItem)
      }
      this.vehiclePagination = newPaginationData
    } catch (error) {
      console.log(error);
    }
  }
  async equipmentTypePaginate() {
    try {
      this.equipmentTypePagination = await this.fetchEquipmentTypeUseCaseImpl(this.equipmentTypeOptions, this.searchEquipmentType)
    } catch (error) {
      console.log(error);
    }
  }
  async clientPaginate() {
    try {
      const newPaginationData = await this.fetchClientUseCaseImpl(this.clientOptions, this.searchClient || this.searchClientInModal || this.searchClientInUpdateModal, this.statusPaginated, this.clientIDToInclude)

      const currentSelectedItem = this.clientPagination.items.find(
        (v) => v.id === this.form.clientID
      )

      if (currentSelectedItem && !newPaginationData.items.some(v => v.id === currentSelectedItem.id)) {
        newPaginationData.items.unshift(currentSelectedItem)
      }
      this.clientPagination = newPaginationData
    } catch (error) {
      console.log(error);
    }
  }

   async technicianPaginate() {
    try {
      this.technicianPagination = await this.fetchTechnicianUseCaseImpl(this.technicianOptions, this.searchTechnician)
    } catch (error) {
      console.log(error);
    }
  }


  async open() {
    const isAdmin = hadPermission(0, 0)

    if (isAdmin) {
      this.dialog = true
      this.modelIDToInclude = null
      this.clientIDToInclude = null
      this.form = equipmentDefault()
      this.searchVehicleInModal = ""
      this.vehicleIDToInclude = null
      this.searchClientInModal = ""
      this.searchModelInModal = ""
      this.searchTechnicianInModal = ""
      await Promise.all([
        this.equipmentTypePaginate(),
        this.modelPaginate(),
        this.vehiclePaginate(),
        this.technicianPaginate()
      ]);
    } else if (hadPermission(2, 1)) {
      this.dialog = true
      this.modelIDToInclude = null
      this.clientIDToInclude = null
      this.form = equipmentDefault()
      this.searchVehicleInModal = ""
      this.vehicleIDToInclude = null
      this.searchClientInModal = "" 
      this.searchModelInModal = ""
      await Promise.all([
        this.equipmentTypePaginate(),
        this.modelPaginate(),
        this.vehiclePaginate()
      ]);
    }
  }

  close() {
    this.dialog = false;
    this.form = equipmentDefault();
    this.searchVehicleInModal = "";
    this.searchModelInModal = "";
    this.searchClientInModal = "";
    this.searchTechnicianInModal = "";
    this.vehicleIDToInclude = null;
    this.modelIDToInclude = null;
    this.clientIDToInclude = null;
  }

  async create() {
    if (this.context.$refs.crud.validate()) {
      try {
        this.loading = true
        if (this.form.id != 0) {
          await this.changeEquipmentUseCaseImpl(this.form.id, this.form)
          snackbar.show({ message: "Alterado com sucesso!!!", color: "#008000", timeout: 3000 })
        } else {
          await this.createEquipmentUseCaseImpl(this.form)
          snackbar.show({ message: "Adicionado com sucesso!!!", color: "#008000", timeout: 3000 })
        }

        await this.refreshUseCaseImpl()
      } catch (error) {
        snackbar.show({ message: error.toString(), color: "#ff0000", timeout: 3000 })
      } finally {
        this.paginate()
        this.loading = false
        this.close()
      }
    }
  }

  async change(item) {
    const isAdmin = hadPermission(0, 0)

    if (isAdmin) {
      this.dialog = true
      this.form = { ...item }
      this.searchVehicleInModal = item.plate
      this.searchModelInModal = item.model
      this.searchClientInModal = item.client
      this.searchTechnicianInModal = item.technician
      this.modelIDToInclude = item.modelID
      this.vehicleIDToInclude = item.vehicleID
      this.clientIDToInclude = item.clientID

      this.modelPagination.items = [{ id: item.modelID, name: item.model }]

      if (item.vehicleID) {
        this.vehiclePagination.items = [{ id: item.vehicleID, plate: item.plate }]
      }

      if (item.clientID) {
        this.clientPagination.items = [{ id: item.clientID, name: item.client }]
      }

      const promises = [
        this.equipmentTypePaginate(),
        this.modelPaginate(),
        this.vehiclePaginate(),
        this.clientPaginate(),
        this.technicianPaginate()
      ];
      
      await Promise.all(promises);
    } else if (hadPermission(2, 2)) {
      this.dialog = true
      this.form = { ...item }
      this.searchVehicleInModal = item.plate
      this.searchModelInModal = item.model
      this.modelIDToInclude = item.modelID
      this.vehicleIDToInclude = item.vehicleID
      this.clientIDToInclude = item.clientID
      this.modelPagination.items = [{ id: item.modelID, name: item.model }]

      if (item.vehicleID) {
        this.vehiclePagination.items = [{ id: item.vehicleID, plate: item.plate }]
      }
      if (item.clientID) {
        this.clientPagination.items = [{ id: item.clientID, name: item.client }]
      }
      const promises = [
        this.equipmentTypePaginate(),
        this.modelPaginate(),
        this.vehiclePaginate()
      ];
      
      await Promise.all(promises);
    }
  }

  async delete(item) {
    try {
      const confirm = await snackbar.confirm({ message: "Deseja realmente excluir o registro?", color: "primary", timeout: 5000 })
      if (confirm) {
        await this.deleteEquipmentUseCaseImpl(item.id)
        this.paginate()
        snackbar.show({ message: "Resgistro excluído com sucesso!", color: "#008000", timeout: 1000 })
      }
    } catch (error) {
      snackbar.show({ message: error.toString() })
    }
  }


  watchOptions() {
    this.paginate()
  }
  watchSearch() {
    this.paginate()
  }
  watchModelOptions() {
    this.modelPaginate()
  }
  watchModelSearch() {
    this.modelPaginate()
  }
  watchVehicleOptions() {
    this.vehiclePaginate()
  }
  watchVehicleSearch() {
    this.vehiclePaginate();
  }
  watchVehicleSearchInModal() {
    this.vehiclePaginate()
  }
  watchVehicleSearchInUpdateModal() {
    this.vehiclePaginate()
  }
  watchEquipmentTypeOptions() {
    this.equipmentTypePaginate()
  }
  watchEquipmentTypeSearch() {
    this.equipmentTypePaginate()
  }
  watchClientOptions() {
    this.clientPaginate()
  }
  watchClientSearch() {
    this.clientPaginate()
  }
  watchClientSearchInModal() {
    this.clientPaginate()
  }
  watchClientSearchInUpdateModal() {
    this.clientPaginate()
  }
  watchTechnicianOptions() {
    this.technicianPaginate()
  }
  watchTechnicianSearch() {
    this.technicianPaginate()
  }
  watchTechnicianSearchInModal() {
    this.technicianPaginate()
  }

  async validateEquipments(equipments) {
    const errors = [];
  
    const paginate = { ...this.options, itemsPerPage: 30000 };
    const tempModelOptions = { ...this.modelOptions, itemsPerPage: 30000 };
    const tempVehicleOptions = { ...this.vehicleOptions, itemsPerPage: 30000 };
    const tempEquipmentTypeOptions = { ...this.equipmentTypeOptions, itemsPerPage: 30000 };
    const tempClientOptions = { ...this.clientOptions, itemsPerPage: 30000 };
    const tempTechnicianOptions = { ...this.technicianOptions, itemsPerPage: 30000 };
  
    const [existingEquipments, models, vehicles, equipmentTypes, clients, technicians] = await Promise.all([
      this.fetchEquipmentUseCaseImpl(paginate, ""),
      this.fetchModelUseCaseImpl(tempModelOptions, "", this.statusPaginated),
      this.fetchVehicleUseCaseImpl(tempVehicleOptions, "", this.statusPaginated),
      this.fetchEquipmentTypeUseCaseImpl(tempEquipmentTypeOptions, ""),
      this.fetchClientUseCaseImpl(tempClientOptions, "", this.statusPaginated),
      this.fetchTechnicianUseCaseImpl(tempTechnicianOptions, "", this.statusPaginated)
    ]);
    const existingNames = existingEquipments.items.map(e => e.name.toLowerCase());
  
    for (const equipment of equipments) {
      const validationErrors = [];
  
      if (!equipment.name || equipment.name.trim() === '') {
        validationErrors.push('Serial é obrigatório');
      }
  
      if (!equipment.modelID) {
        validationErrors.push('Modelo é obrigatório');
      } else if (!models.items.some(m => m.id === equipment.modelID)) {
        validationErrors.push('ID do Modelo não existe');
      }
  
      if (!equipment.equipmentTypeID) {
        validationErrors.push('Tipo de equipamento é obrigatório');
      } else if (!equipmentTypes.items.some(e => e.id === equipment.equipmentTypeID)) {
        validationErrors.push('ID do Tipo de equipamento não existe');
      }
  
      if (equipment.vehicleID && !vehicles.items.some(v => v.id === equipment.vehicleID)) {
        validationErrors.push('ID do Veículo não existe');
      }
  
      if (equipment.clientID && !clients.items.some(c => c.id === equipment.clientID)) {
        validationErrors.push('ID do Cliente não existe');
      }

      if (equipment.technicianID && !technicians.items.some(t => t.id === equipment.technicianID)) {
        validationErrors.push('ID do Técnico não existe');
      }

      if (existingNames.includes(equipment.name.toLowerCase())) {
        validationErrors.push('Serial já existe');
      }
  
      const duplicatesInImport = equipments.filter(e => 
        e.name.toLowerCase() === equipment.name.toLowerCase()
      );
      if (duplicatesInImport.length > 1) {
        validationErrors.push('Serial duplicado na planilha');
      }
  
      if (validationErrors.length > 0) {
        errors.push({
          serial: equipment.name,
          errors: validationErrors
        });
      }
    }
    return errors;
  }

  async exportExcel() {
    try {
      this.loadingBtnExcel = true;
      const paginate = { ...this.options };
      paginate.itemsPerPage = 30000;
      
      const response = await this.fetchEquipmentUseCaseImpl(paginate, "");
      
      await generateExcelFile(
        response.items,
        headersExcel,
        this.permissionID,
        'equipamentos',
        'equip'
      );
      
    } catch (error) {
      snackbar.show({ message: error.toString() });
    } finally {
      this.loadingBtnExcel = false;
    }
  }

  changeStatus() {
    this.paginate()
  }

  async handleFileUpload(event) {
    try {
      const file = event.target.files[0];
      this.loadingImport = true;
      
      const tempModelOptions = { ...this.modelOptions, itemsPerPage: 30000 };
      const tempVehicleOptions = { ...this.vehicleOptions, itemsPerPage: 30000 };
      const tempEquipmentTypeOptions = { ...this.equipmentTypeOptions, itemsPerPage: 30000 };
      const tempClientOptions = { ...this.clientOptions, itemsPerPage: 30000 };
      const tempTechnicianOptions = { ...this.technicianOptions, itemsPerPage: 30000 };
      
      const [models, vehicles, equipmentTypes, clients, technicians] = await Promise.all([
        this.fetchModelUseCaseImpl(tempModelOptions, "", this.statusPaginated),
        this.fetchVehicleUseCaseImpl(tempVehicleOptions, "", this.statusPaginated),
        this.fetchEquipmentTypeUseCaseImpl(tempEquipmentTypeOptions, ""),
        this.fetchClientUseCaseImpl(tempClientOptions, "", this.statusPaginated),
        this.fetchTechnicianUseCaseImpl(tempTechnicianOptions, "", this.statusPaginated)
      ]);
      
      const workbook = await XLSX.read(await file.arrayBuffer());
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const data = XLSX.utils.sheet_to_json(worksheet);
      
      this.previewData = data.map(row => {
        const serial = row.Serial || row.SERIAL || null;
        const mac = row.Mac || row.MAC || null;
        const description = row.Description || row.DESCRICAO || null;
        const modelID = row.ModelID || row.MODELO_ID || 0;
        const vehicleID = row.VehicleID || row.VEICULO_ID || null;
        const equipmentTypeID = row.EquipmentTypeID || row.TIPO_EQUIPAMENTO_ID || 0;
        const clientID = row.ClientID || row.CLIENTE_ID || null;
        const technicianID = row.TechID || row.TECNICO_ID || null;
        const model = models.items.find(m => m.id === modelID);
        const vehicle = vehicles.items.find(v => v.id === vehicleID);
        const equipmentType = equipmentTypes.items.find(e => e.id === equipmentTypeID);
        const client = clients.items.find(c => c.id === clientID);
        const technician = technicians.items.find(t => t.id === technicianID);

        return {
          name: serial ? String(serial) : null,
          modelID,
          modelName: model ? model.name : '',
          vehicleID,
          plateNumber: vehicle ? vehicle.plate : '',
          equipmentTypeID, 
          equipmentTypeName: equipmentType ? equipmentType.name : '',
          mac: mac ? String(mac) : null,
          clientID,
          clientName: client ? client.name : '',
          active: Boolean(row.active || row.ATIVO),
          description: description ? String(description) : null,
          technicianID: technician ? technician.id : null,
          technicianName: technician ? technician.name : '',
        };
      });
  
      this.dialogPreviewImport = true;
  
    } catch (error) {
      snackbar.show({ 
        message: error.toString(),
        color: "#ff0000" 
      });
    } finally {
      this.loadingImport = false;
      event.target.value = '';
    }
  }
  
  async confirmImport() {
    try {
      this.loadingImport = true;
  
      const validationErrors = await this.validateEquipments(this.previewData);
      
      if (validationErrors.length > 0) {
        const errorMessage = validationErrors.map(error => 
          `Serial ${error.serial}: ${error.errors.join(', ')}`
        ).join('\n');
  
        snackbar.show({ 
          message: `Erros na validação:\n${errorMessage}`,
          color: "#ff0000",
          timeout: 3000
        });
        return;
      }
  
      for (const equipment of this.previewData) {
        try {
          await this.createEquipmentUseCaseImpl(equipment);
        } catch (error) {
          throw new Error(`Erro ao importar ${equipment.name}: ${error.toString()}`);
        }
      }
      snackbar.show({ 
        message: "Equipamentos importados com sucesso!", 
        color: "#008000",
        timeout: "3000"
      });
      
      await this.paginate();
      this.dialogPreviewImport = false;
      this.previewData = [];
      
    } catch (error) {
      snackbar.show({ 
        message: error.toString(),
        color: "#ff0000" 
      });
    } finally {
      this.loadingImport = false;
    }
  }

  async openUpdateClientModal() {
    this.dialogUpdateClient = true;
    this.clientIDForUpdate = null;
    this.searchClientInUpdateModal = ""; 
    await this.clientPaginate();
  }

  closeUpdateClientModal() {
    this.dialogUpdateClient = false;
    this.searchClientInUpdateModal = "";
  }

  async updateClient() {
    if (this.context.$refs.crudUpdateClient.validate() && this.clientIDForUpdate != null) {
      try {
        this.loadingUpdateClient = true

        for (const equipment of this.selectedItems) {
          equipment.clientID = this.clientIDForUpdate
          await this.changeEquipmentUseCaseImpl(equipment.id, equipment)
        }

        snackbar.show({ message: "Alterado com sucesso!!!", color: "#008000", timeout: 3000 })
        this.clientIDForUpdate = null
        this.dialogUpdateClient = false
        this.context.$refs.crudUpdateClient.resetValidation()
        this.paginate()
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingUpdateClient = false
        this.closeUpdateClientModal(); 
      }
    }
  }

  async updateVehicleOpen(data) {
    this.dialogUpdateVehicle = true
    this.formUpdateVehicle = { ...data }
    this.searchVehicleInUpdateModal = data.plate
    this.vehicleIDToInclude = data.vehicleID

    if (data.vehicleID) {
      this.vehiclePagination.items = [{ id: data.vehicleID, plate: data.plate }]
    }
    
    await this.vehiclePaginate()
  }
  
  closeUpdateVehicle() {
     this.dialogUpdateVehicle = false;
     this.formUpdateVehicle = {}
     this.searchVehicleInUpdateModal = ""
     this.vehicleIDToInclude = null
  }

  generateQrCodeOpen(data) {
    this.dialogGenerateQrCode = true
    this.formCode = {
      serial: data.name,
      code: '',
      description: '',
      descriptionReason: '',
      equipmentID: data.id,
      vehicleID: data.vehicleID
    }
  }

  async updateVehicle() {
    if (this.context.$refs.crudUpdateVehicle.validate()) {
      try {
        this.loadingUpdateVehicle = true
        await this.changeEquipmentUseCaseImpl(this.formUpdateVehicle.id, this.formUpdateVehicle)
        snackbar.show({ message: "Alterado com sucesso!!!", color: "#008000", timeout: 3000 })
        this.closeUpdateVehicle()
        this.paginate()
      } catch (error) {
        snackbar.show({ message: error.toString(), color: "#ff0000", timeout: 3000 })
      } finally {
        this.loadingUpdateVehicle = false
      }
    }
  }

  qrCode() {
    const report = new QRCodeReport()
    report.call([...this.selectedItems])
  }

  async generateCode() {
    if (this.context.$refs.crudGenerateCodeVehicle.validate()) {
      try {
        this.loading = true
        this.code = await this.createReleaseUseCaseImpl(this.formCode)
        this.dialogGenerateQrCodeCreated = true

        setTimeout(() => {
          this.dialogGenerateQrCodeCreated = false
          this.code = {}
        }, 15000)
      } catch (error) {
        snackbar.show({ message: error, color: "#ff0000", timeout: 3000 })
      } finally {
        this.paginate()
        this.loading = false
        this.dialogGenerateQrCode = false
      }
    }
  }

}

export default EquipmentController